import { useI18n } from 'vue-i18n';
import { date, number, string } from 'yup';

export function useFormValidation() {
  const { t } = useI18n();

  function dateRequiredValidation() {
    return date().required(
      t('formsValidations.rules_error_messages.required', {
        field: t('formsValidations.fields.collection_date'),
      }),
    );
  }
  function numberValidationRequiredMinMaxValue(field: string, minValue: number, maxValue: number) {
    return number()
      .transform((value) => (Number.isNaN(value) ? 0 : value))
      .required('')
      .min(
        minValue,
        t('formsValidations.rules_error_messages.min_value', {
          field: t(`formsValidations.fields.${field}`),
          min_value: minValue,
        }),
      )
      .max(
        maxValue,
        t('formsValidations.rules_error_messages.max_value', {
          field: t(`formsValidations.fields.${field}`),
          max_value: maxValue,
        }),
      );
  }
  function numberValidationMaxValue(field: string, maxValue: number) {
    return number()
      .transform((value) => (Number.isNaN(value) ? 0 : value))
      .max(
        maxValue,
        t('formsValidations.rules_error_messages.max_value', {
          field: t(`formsValidations.fields.${field}`),
          max_value: maxValue,
        }),
      );
  }
  function textMaxCharsValidation(field: string, maxChars: number, ErrorText: string = '') {
    if (ErrorText) {
      return string().max(maxChars, ErrorText);
    }

    return string().max(
      maxChars,
      t('formsValidations.rules_error_messages.max_chars', {
        field: t(`formsValidations.fields.${field}`),
        max_chars: maxChars,
      }),
    );
  }
  function textRequiredValidation(field: string) {
    return string().required(
      t('formsValidations.rules_error_messages.required', {
        field: t(`formsValidations.fields.${field.split(':')[0]}`),
      }),
    );
  }
  function textRequiredMaxCharsValidation(field: string, maxChars: number) {
    return string()
      .required('')
      .max(
        maxChars,
        t('formsValidations.rules_error_messages.max_chars', {
          field: t(`formsValidations.fields.${field}`),
          max_chars: maxChars,
        }),
      );
  }
  function textRequiredMinMaxCharsValidation(field: string, minChars: number, maxChars: number) {
    return textRequiredMaxCharsValidation(field, maxChars).min(
      minChars,
      t('formsValidations.rules_error_messages.min_chars', {
        field: t(`formsValidations.fields.${field}`),
        min_chars: minChars,
      }),
    );
  }
  function phoneNumberValidation() {
    return textRequiredMinMaxCharsValidation('phone_number', 11, 8);
  }
  function emailValidation(field: string) {
    return textRequiredValidation(field).email('Must be a valid email!');
  }

  return {
    dateRequiredValidation,
    numberValidationRequiredMinMaxValue,
    numberValidationMaxValue,
    textMaxCharsValidation,
    textRequiredValidation,
    textRequiredMaxCharsValidation,
    textRequiredMinMaxCharsValidation,
    phoneNumberValidation,
    emailValidation,
  };
}
